// This file is auto-generated by @hey-api/openapi-ts

export enum Bathroom {
    SHARED = 'shared',
    OWN = 'own'
}

export type Listing = {
    id?: string;
    owner?: {
        /**
         * ID of the account
         */
        id?: string;
        /**
         * Name of the account holder
         */
        name?: string;
        /**
         * URL of the profile picture
         */
        profilePicture?: string;
        email?: string;
    };
    rent?: number;
    bond?: number;
    billsIncluded?: boolean;
    latitude?: number;
    longitude?: number;
    suburb?: string;
    postcode?: string;
    state?: string;
    parking?: boolean;
    bathroom?: Bathroom;
    roomType?: RoomType;
    furnished?: boolean;
    title?: string;
    description?: string;
    images?: Array<{
        mediaId?: string;
        small?: string;
        large?: string;
    }>;
    availableFrom?: string;
    minimumStay?: MinimumStay;
    maximumStay?: MaximumStay;
    /**
     * Current status of the listing (e.g., REVIEW, APPROVED, REJECTED, PAUSED)
     */
    status?: Status;
    /**
     * Reason for rejection, if applicable
     */
    rejection_reason?: string;
    /**
     * Timestamp when the listing was created
     */
    created_at?: string;
};

export type ListingDraft = {
    id?: (string) | null;
    draft?: (boolean) | null;
    roomType?: (RoomType) | null;
    bathroom?: (Bathroom) | null;
    furnished?: (boolean) | null;
    parking?: (boolean) | null;
    rent?: (number) | null;
    bond?: (number) | null;
    billsIncluded?: (boolean) | null;
    availableFrom?: (string) | null;
    minimumStay?: (MinimumStay) | null;
    maximumStay?: (MaximumStay) | null;
    localityId?: string;
    localityName?: string;
    addressId?: (string) | null;
    addressName?: (string) | null;
    image_media_ids?: Array<(string)> | null;
    image_url_cache?: Array<(string)> | null;
    title?: (string) | null;
    description?: (string) | null;
};

export type ListingResponse = {
    listingId?: (string) | null;
    errorMessage?: string;
};

export type LocalityInfo = {
    id?: string;
    postcode?: string;
    name?: string;
    state?: string;
    searchQueryType?: SearchQueryType;
};

export enum MaximumStay {
    _1_WEEK = '1 week',
    _1_MONTH = '1 month',
    _2_MONTHS = '2 months',
    _3_MONTHS = '3 months',
    _6_MONTHS = '6 months',
    _9_MONTHS = '9 months',
    _12_MONTHS_ = '12 months+'
}

export enum MinimumStay {
    NO_MINIMUM = 'no minimum',
    _1_WEEK = '1 week',
    _1_MONTH = '1 month',
    _2_MONTHS = '2 months',
    _3_MONTHS = '3 months',
    _6_MONTHS = '6 months',
    _9_MONTHS = '9 months',
    _12_MONTHS = '12 months'
}

export type PublishRequest = {
    /**
     * The ID of the draft associated with the listing.
     */
    draftId?: string;
    roomType: RoomType;
    bathroom: Bathroom;
    furnished: boolean;
    parking: boolean;
    rent: number;
    bond: number;
    billsIncluded: boolean;
    availableFrom: string;
    minimumStay: MinimumStay;
    maximumStay: MaximumStay;
    localityId?: string;
    streetAddress?: string;
    addressId?: string;
    image_media_ids: Array<(string)>;
    title?: string;
    description: string;
};

export enum RoomType {
    SHARED = 'shared',
    OWN = 'own'
}

export enum SearchQueryType {
    LOCALITY = 'locality',
    POSTCODE = 'postcode'
}

export enum Status {
    REVIEW = 'review',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    PAUSED = 'paused'
}

export type UpdateListing = {
    rent?: number;
    bond?: number;
    billsIncluded?: boolean;
    parking?: boolean;
    bathroom?: Bathroom;
    roomType?: RoomType;
    furnished?: boolean;
    title?: string;
    description?: string;
    images?: Array<(string)>;
    availableFrom?: string;
    minimumStay?: MinimumStay;
    maximumStay?: MaximumStay;
};

export type GetApiListingsData = {
    /**
     * Maximum distance from the provided coordinates (in kilometers)
     */
    distance?: number;
    /**
     * Latitude of the center point for distance-based search
     */
    latitude?: number;
    /**
     * Number of items per page
     */
    limit?: number;
    /**
     * List of locality ids.
     */
    localities?: Array<(string)>;
    /**
     * Longitude of the center point for distance-based search
     */
    longitude?: number;
    /**
     * Page number (1-based indexing)
     */
    page?: number;
    postcodes?: Array<(string)>;
    /**
     * Timestamp of when the search was initiated (ISO 8601 format). Used to maintain consistency across pages.
     */
    snapshot?: string;
};

export type GetApiListingsResponse = ({
    listings?: Array<Listing>;
    localityInfo?: Array<LocalityInfo>;
    pagination?: {
        /**
         * Current page number
         */
        currentPage?: number;
        /**
         * Total number of pages
         */
        totalPages?: number;
        /**
         * Total number of items matching the search criteria
         */
        totalItems?: number;
        /**
         * Timestamp of when the search was initiated. Use this in subsequent page requests to maintain consistency.
         */
        snapshotTimestamp?: string;
    };
});

export type DeleteApiListingsByIdData = {
    /**
     * The ID of the listing to delete
     */
    id: string;
};

export type DeleteApiListingsByIdResponse = (void);

export type PatchApiListingsByIdData = {
    /**
     * The ID of the listing to update
     */
    id: string;
    requestBody: UpdateListing;
};

export type PatchApiListingsByIdResponse = (Listing);

export type GetApiListingsDraftsResponse = (Array<ListingDraft>);

export type PostApiListingsDraftsData = {
    requestBody: ListingDraft;
};

export type PostApiListingsDraftsResponse = (ListingResponse);

export type PostApiListingsPublishData = {
    requestBody: PublishRequest;
};

export type PostApiListingsPublishResponse = (ListingResponse);

export type GetApiListingData = {
    /**
     * The ID of the listing to retrieve.
     */
    id: string;
};

export type GetApiListingResponse = (Listing);

export type GetApiListingsByIdRelatedData = {
    /**
     * The ID of the listing to find related listings for
     */
    id: string;
};

export type GetApiListingsByIdRelatedResponse = (Array<Listing>);

export type GetApiListingsMyListingsResponse = (Array<Listing>);